<template>
  <div
    class="col-lg-12 ctr_trm"
    @copy.prevent
    @cut.prevent
    @selectstart.prevent
  >
    <p class="p1 subtitle">PT Digital Kripto Indonesia</p>
    <p class="p1">
      Perjanjian Konsumen ini, sebagaimana diubah, ditambah atau diganti dari
      waktu ke waktu ("Perjanjian Konsumen"), adalah kontrak antara anda dan PT
      Digital Kripto Indonesia, sebuah perseroan terbatas Indonesia dengan
      kantor terdaftar di AXA Tower Lt 37 Suite (6), Kuningan city, Axa Tower,
      Jl. Prof. DR. Satrio, RT.14/RW.4, Kuningan, Karet Kuningan, Kecamatan
      Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta, didirikan
      berdasarkan hukum Negara Republik Indonesia ("Pegasus Exchange"). Dengan
      mengakses Layanan Pegasus Exchange kami (sebagaimana didefinisikan di
      bawah), anda akan dianggap telah menerima Perjanjian Konsumen ini.
      Perjanjian Konsumen ini berlaku kepada seluruh Konsumen Pegasus Exchange.
      Rujukan dalam Perjanjian Konsumen ini kepada "kami" atau "milik kami"
      berarti Pegasus Exchange, dan rujukan kepada "anda" atau "milik anda"
      adalah seseorang yang menyepakati Perjanjian Konsumen ini dengan Pegasus
      Exchange. Anda harus membaca secara keseluruhan, setuju dengan, dan
      menerima semua syarat dan ketentuan yang ada dalam Perjanjian Konsumen
      ini, termasuk namun tidak terbatas pada dokumen, kebijakan, materi atau
      informasi apa pun yang merupakan satu kesatuan berdasarkan rujukan pada
      Perjanjian Konsumen ini dan/atau setiap hal tersebut yang dimiliki oleh
      kami, sebelum anda menggunakan Layanan Pegasus Exchange apa pun. Jika anda
      tidak menyetujui substansi dari Perjanjian Konsumen ini dan/atau perubahan
      apa pun yang dilakukan dari waktu ke waktu dan kapan pun, harap segera
      berhenti menggunakan layanan yang disediakan Situs Web kami atau berhenti
      masuk ke Situs Web kami. Saat anda masuk ke Situs Web kami atau
      menggunakan layanan apa pun yang ditawarkan Situs Web kami atau terlibat
      dalam aktivitas serupa lainnya, anda dianggap telah memahami dan
      sepenuhnya menyetujui semua syarat dan ketentuan Perjanjian ini, termasuk
      setiap dan semua perubahan. Layanan Pegasus Exchange berarti berbagai
      layanan yang diberikan kepada anda oleh Pegasus Exchange yang berdasarkan
      teknologi internet dan/atau teknologi blockchain dan ditawarkan melalui
      situs web, aplikasi seluler, dan bentuk lainnya (termasuk bentuk-bentuk
      yang akan dimungkinkan oleh perkembangan teknologi di kemudian hari) yang
      dimiliki oleh Pegasus Exchange. Layanan Pegasus Exchange termasuk tetapi
      tidak terbatas pada Platform Perdagangan Aset Kripto dan setiap layanan
      baru yang akan disediakan oleh Pegasus Exchange ("Layanan Pegasus
      Exchange"). Kami sangat menyarankan, bahwa pada saat anda membaca
      Perjanjian Konsumen ini, anda juga mengakses dan membaca informasi yang
      dimuat di halaman dan situs web lainnya dari Pegasus Exchange sebagaimana
      dimaksud dalam dokumen ini, karena halaman dan situs web tersebut dapat
      memuat syarat dan ketentuan lanjutan yang berlaku kepada anda sebagai
      Konsumen. Konsumen berarti semua individu yang mengakses, mengunduh, atau
      menggunakan Layanan Pegasus Exchange yang memenuhi kriteria dan ketentuan
      kelayakan yang ditetapkan oleh Pegasus Exchange serta hukum dan peraturan
      perundang-undangan yang berlaku ("Konsumen"). Perjanjian Konsumen ini
      membatasi hak dan kewajiban antara anda dan Pegasus Exchange, dan tidak
      melibatkan hubungan hukum dan perselisihan hukum termasuk namun tidak
      terbatas antara konsumen situs web ini, situs web lain, pihak ketiga
      lainnya, dan anda karena transaksi aset digital ini. Perdagangan aset
      digital sangat berisiko dan oleh karena itu tidak cocok untuk sebagian
      besar orang. Konsumen mengetahui dan memahami bahwa investasi pada aset
      digital dapat mengakibatkan kerugian sebagian atau seluruh investasi
      Konsumen dan oleh karena itu Konsumen disarankan untuk memutuskan jumlah
      investasi Konsumen berdasarkan kemampuan menahan kerugian Konsumen. Selain
      risiko-risiko yang disebutkan di atas, terdapat juga risiko-risiko yang
      tidak dapat diprediksi. Oleh karena itu, Konsumen disarankan untuk
      mempertimbangkan secara hati-hati dan menggunakan penilaian yang jelas
      untuk mengetahui posisi keuangan konsumen dan risiko yang disebutkan di
      atas sebelum mengambil keputusan apa pun mengenai pembelian dan penjualan
      aset digital; segala kerugian yang timbul karenanya akan ditanggung oleh
      konsumen dan Pegasus Exchange tidak bertanggung jawab dalam bentuk apa
      pun. Perjanjian Konsumen ini merupakan kontrak antara anda dan Pegasus
      Exchange.
    </p>
    <h2 class="text_h">1. Profil Perseroan</h2>
    <p class="p1">
      <strong>Nama Perusahaan:</strong> PT Digital Kripto Indonesia
    </p>
    <p class="p1">
      <strong>Alamat Perusahaan:</strong> AXA Tower, Kuningan city, Axa Tower,
      Jl. Prof. DR. Satrio, RT.14/RW.4, Kuningan, Karet Kuningan, Kecamatan
      Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta
    </p>
    <p class="p1">
      <strong>Situs Web:</strong>
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
    </p>
    <p class="p1">
      <strong>Nomer Telepon/Telephone Number:</strong> 021 3970 3399
    </p>
    <p class="p1">
      <strong>Surat Elektronik/Email:</strong>
      <a href="mailto:corporateservice@pegasusexchange.id"
        >corporateservice@pegasusexchange.id</a
      >
    </p>
    <p class="p1">
      Dengan membaca Profil Perusahaan di atas dan menyetujui Perjanjian
      Konsumen ini, anda dengan ini menyatakan, menjamin dan menerima bahwa anda
      telah membaca Profil Perusahaan dan menyetujui isinya.
    </p>
    <h2 class="text_h">2. Daftar Aset Kripto yang Diperdagangkan</h2>
    <p class="p1">
      Dengan menyetujui Perjanjian Konsumen ini, maka anda menyatakan, menjamin
      dan menerima bahwa anda telah menerima dan membaca serta memahami dan
      menyetujui isi Daftar Aset Kripto yang Diperdagangkan oleh Pegasus
      Exchange. Silahkan merujuk kepada Situs Web untuk daftar lengkap terhadap
      Daftar Aset Kripto yang Diperdagangkan pada Jadwal Biaya, yang merupakan
      bagian yang tidak terpisahkan dari Perjanjian Konsumen ini.
    </p>
    <h2 class="text_h">3. Pemberitahuan Pernyataan Risiko</h2>
    <p class="p1">
      Dengan menyetujui Perjanjian Konsumen ini, maka anda menyatakan, menjamin
      dan menerima bahwa anda telah menerima dan membaca serta memahami dan
      menyetujui Pemberitahuan dan Pernyataan Risiko kami. Silahkan merujuk
      kepada Situs Web untuk Dokumen Pemberitahuan dan Pernyataan Risiko yang
      lengkap, yang merupakan bagian yang tidak terpisahkan dari Perjanjian
      Konsumen ini.
    </p>
    <h2 class="text_h">4. Syarat dan Ketentuan</h2>
    <p class="p1">
      Dengan menyetujui Perjanjian Konsumen ini, maka anda menyatakan, menjamin
      dan menerima bahwa anda telah menerima dan membaca serta memahami dan
      menyetujui Syarat dan Ketentuan kami. Silahkan merujuk ke Situs Web untuk
      Syarat dan Ketentuan yang lengkap, yang merupakan bagian yang tidak
      terpisahkan dari Perjanjian Konsumen ini.
    </p>
    <h2 class="text_h">5. Syarat dan Ketentuan OTC</h2>
    <p class="p1">
      Dengan menyetujui Perjanjian Konsumen ini, maka anda menyatakan, menjamin
      dan menerima bahwa anda telah menerima dan membaca serta memahami dan
      menyetujui Syarat dan Ketentuan OTC kami. Silahkan merujuk ke Situs Web
      untuk Syarat dan Ketentuan OTC yang lengkap, yang merupakan bagian yang
      tidak terpisahkan dari Perjanjian Konsumen ini.
    </p>
    <h2 class="text_h">6. Kebijakan Privasi</h2>
    <p class="p1">
      Dengan menyetujui Perjanjian Konsumen ini, maka anda menyatakan, menjamin
      dan menerima bahwa anda telah menerima dan membaca serta memahami dan
      menyetujui Kebijakan Privasi kami. Silahkan merujuk ke Situs Web untuk
      Kebijakan Privasi yang lengkap, yang merupakan bagian yang tidak
      terpisahkan dari Perjanjian Konsumen ini.
    </p>
    <h2 class="text_h">7. Tata Cara Perdagangan</h2>
    <p class="p1">
      Dalam menyediakan Layanan Pegasus Exchange, Pegasus Exchange akan
      menawarkan kepada Konsumennya layanan yang terkait dengan perdagangan Aset
      Keuangan Digital melalui Situs Web dan aplikasinya serta platform
      lain-lain yang mungkin dapat disediakan oleh Pegasus Exchange di kemudian
      ("Platform Pegasus Exchange"). Daftar dan harga Aset Keuangan Digital yang
      diperdagangkan dapat diakses oleh Konsumen melalui Tata Cara Perdagangan
      Pegasus Exchange. Dengan menyetujui Perjanjian Konsumen ini, maka anda
      menyatakan, menjamin dan menerima bahwa anda telah menerima dan membaca
      serta memahami dan menyetujui Aturan Perdagangan tersebut. Silahkan
      merujuk kepada Situs Web untuk Aturan Perdagangan yang lengkap, yang
      merupakan bagian yang tidak terpisahkan dari Perjanjian Konsumen ini.
    </p>
    <h2 class="text_h">8. Persyaratan Penutupan Akun</h2>
    <p class="p1">
      Dalam menyediakan Layanan Pegasus Exchange, apabila Konsumen ingin
      melakukan penutupan akun pada Platform Pegasus Exchange, maka Konsumen
      wajib mengikuti prosedur persyaratan penutupan akun Pegasus Exchange.
      Prosedur persyaratan penutupan akun dapat diakses oleh Konsumen melalui
      Panduan Langkah-Langkah untuk Menghapus Akun Pegasus Exchange Anda. Dengan
      menyetujui Perjanjian Konsumen ini, anda dengan ini menyatakan, menjamin
      dan menerima bahwa anda telah membaca dan menyetujui serta memahami dan
      menyetujui persyaratan penutupan akun tersebut. Silahkan merujuk kepada
      Situs Web untuk persyaratan penutupan akun yang lengkap, yang merupakan
      bagian yang tidak terpisahkan dari Perjanjian Konsumen ini.
    </p>
    <h2 class="text_h">9. Prosedur dan Kebijakan Lainnya</h2>
    <p class="p1">
      Dengan menyetujui Perjanjian Konsumen ini, anda dengan ini menyatakan,
      menjamin, menerima dan setuju bahwa anda juga akan mengikuti segala
      prosedur dan kebijakan yang dimiliki oleh Pegasus Exchange dalam
      menyediakan Layanan Pegasus Exchange.
    </p>
    <h2 class="text_h">10. Perubahan-Perubahan</h2>
    <p class="p1">
      Perjanjian Konsumen dan seluruh dokumen, kebijakan, materi, atau informasi
      kami serta setiap kebijakan sebagaimana disebutkan di atas dapat diubah
      dan/atau diperbaharui sewaktu-waktu tanpa pemberitahuan terlebih dahulu.
      Pegasus Exchange merekomendasikan anda untuk membaca dan memeriksa Situs
      Web kami secara hati-hati untuk mempelajari setiap perubahan tersebut.
      Dengan melanjutkan akses dan penggunaan Layanan Kami, Konsumen dianggap
      telah menyetujui setiap perubahan yang terdapat pada Perjanjian Konsumen
      dan kebijakan-kebijakan lainnya.
    </p>
    <p class="p1 updated">
      <em>Terakhir Diperbarui pada tanggal 20/05/2026.</em>
    </p>
  </div>
</template>

<script>
// node_modules

// applibs

export default {
  components: {},
  data() {
    return {
      web_domain: "pegasusexchange.id",
    };
  },
};
</script>
<style scoped>
.text_h {
  margin-left: -20px;
  padding-top: 20px;
}
h2.head_txt {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 18pt;
}
.subtitle {
  font-weight: 600;
  margin-bottom: 1rem;
}
.updated {
  margin-top: 2rem;
  font-style: italic;
}
.p1 {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 16px;
}
.ul-letter,
.ul-sub {
  margin: 0 0 14pt 0;
  padding-left: 32pt;
  list-style: none;
}
.li-letter,
.li-sub {
  margin-top: 10pt;
  text-align: justify;
  font-size: 16px;
}
.li-label {
  font-weight: 600;
}
.text_h,
h1,
h2 {
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
}
.ctr_trm {
  max-width: 932px;
  padding: 0 20px;
  z-index: 995;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.head_txt {
  font-size: 28px;
  margin-left: -20px;
}
.ctr_trm a {
  color: #4da3ff;
  word-break: break-all;
}
@media (max-width: 500px) {
  .text_h,
  .head_txt,
  h1,
  h2 {
    font-size: 16px;
    margin-top: 20px;
  }
  .p1,
  .li-letter,
  .li-sub {
    font-size: 14px;
  }
}
</style>
